import { Box, Button, CardMedia, Typography, useTheme } from "@mui/material";
import { Grid, GridSize, ResponsiveStyleValue } from "@mui/system";
import { addToRefsGeneric } from "../../utils/funtions";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useEffect, useRef } from "react";
import gsap from "gsap";
import { useNavigate } from "react-router-dom";

gsap.registerPlugin(ScrollTrigger);

type CardCategoryProps = {
  src: string;
  label: string;
  size?: ResponsiveStyleValue<GridSize>;
  ref?: (el: HTMLDivElement | null) => void;
  route?: string;
};

export const CardCategory = ({
  src,
  label,
  size,
  ref,
  route,
}: CardCategoryProps) => {
  const theme = useTheme();

  const imageRef = useRef<HTMLImageElement[]>([]);
  const addImageRef = addToRefsGeneric(imageRef);

  const navigate = useNavigate();

  const onNavigate = () => {
    navigate(route ?? "");
  };

  useEffect(() => {
    const ctx = gsap.context(() => {
      if (!imageRef.current) return;

      imageRef.current.forEach((el) => {
        gsap.fromTo(
          el,
          { y: "-20%", scale: 1.5 },
          {
            y: "20%",
            scale: 1,
            ease: "none",
            scrollTrigger: {
              trigger: el,
              start: "top bottom",
              end: "bottom top",
              scrub: true,
            },
          }
        );
      });
    });

    return () => ctx.revert();
  }, []);

  return (
    <Grid
      ref={ref}
      onClick={onNavigate}
      size={size}
      position="relative"
      borderRadius={2}
      overflow="hidden" maxWidth={400}
      height={{ xs: 270, sm: 400, md: 500 }}
      sx={{
        zIndex: 888,
        "&:hover": {
          cursor: "pointer",
        },
      }}
    >
      <Box
        
        sx={{
          position: "relative",
          width: "100%",
          height: "100%",
          overflow: "hidden",
        }}
      >
        <CardMedia
          ref={addImageRef}
          alt={label}
          image={src}
          component="img"
          loading="lazy"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
            willChange: "transform",
          }}
        />
      </Box>

      <Box
        position="absolute"
        bottom={{ xs: 25, md: 0 }}
        sx={{
          width: "100%",
          height: "100%",
          boxShadow: {
            xs: "0px 100px 40px -30px rgba(0, 0, 0, 0.75) inset",
            md: "0px -100px 40px -30px rgba(0, 0, 0, 0.75) inset",
          },
        }}
      />
      <Box
        position="absolute"
        width="100%"
        top={{ xs: 25, md: 445 }}
        display="flex"
        flexWrap="wrap"
      >
        <Box marginInline={{ xs: 3, md: 5 }}>
          <Typography
            sx={{
              fontSize: {
                xs: 14,
                md: 25,
              },
              textTransform: "uppercase",
              color: "white",
              fontWeight: 800,
            }}
          >
            {label}
          </Typography>

          <Typography
            sx={{
              left: { xs: 12, md: 20 },
              top: { xs: -15, md: -20 },
              fontSize: {
                xs: 10,
                md: 15,
              },
              letterSpacing: 2,
              position: "absolute",
              color: theme.palette.background.paper,
            }}
          >
            Featured
          </Typography>
          <Button
            onClick={onNavigate}
            size="small"
            sx={{
              position: "absolute",
              right: 10,
              top: { xs: 205, sm: 330, md: 5 },
              backgroundColor: "white",
              boxShadow: "rgba(0, 0, 0, 0.2) 0px 0px 20px 5px",
              color: theme.palette.secondary.main,
            }}
          >
            Buy
          </Button>
        </Box>
      </Box>
    </Grid>
  );
};
